// Redirect page for /:locale/:projectId/medical

import { Navigate, useParams, useLocation } from 'react-router-dom'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { useTranslation } from 'react-i18next'

export function MedicalRedirectPage() {
  const { projectId } = useParams<{ projectId: string }>()
  const { pathname } = useLocation()
  const { i18n } = useTranslation()
  const locale = i18n.language
  const { isFeatureActivated } = useCurrentProject()
  const isDashboardFeatureActivated = isFeatureActivated('dashboard') || isFeatureActivated('dashboard-v2')

  // Only redirect if we're exactly on /medical or /medical/
  const shouldRedirect =
    pathname === `/${locale}/${projectId}/medical` || pathname === `/${locale}/${projectId}/medical/`

  if (!shouldRedirect) {
    return null
  }

  const url = isDashboardFeatureActivated ? 'dashboard' : 'patients'

  return <Navigate to={url} replace />
}
